var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5082_8405)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5082_8405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0007 13.333C34.7265 13.333 29.5708 14.897 25.1855 17.8272C20.8001 20.7573 17.3822 24.9221 15.3639 29.7948C13.3455 34.6675 12.8174 40.0293 13.8464 45.2021C14.8753 50.3749 17.4151 55.1265 21.1445 58.8559C24.8739 62.5853 29.6254 65.125 34.7983 66.1539C39.9711 67.1829 45.3329 66.6548 50.2056 64.6365C55.0783 62.6181 59.243 59.2002 62.1732 54.8149C65.1034 50.4296 66.6673 45.2738 66.6673 39.9997C66.6673 32.9272 63.8578 26.1445 58.8568 21.1435C53.8559 16.1425 47.0731 13.333 40.0007 13.333ZM36.6896 26.6663C36.6896 25.7823 37.0407 24.9344 37.6659 24.3093C38.291 23.6842 39.1388 23.333 40.0229 23.333C40.9069 23.333 41.7548 23.6842 42.3799 24.3093C43.005 24.9344 43.3562 25.7823 43.3562 26.6663V41.9774C43.3562 42.4152 43.27 42.8486 43.1025 43.2531C42.935 43.6575 42.6894 44.0249 42.3799 44.3345C42.0704 44.644 41.7029 44.8895 41.2985 45.0571C40.8941 45.2246 40.4606 45.3108 40.0229 45.3108C39.5851 45.3108 39.1517 45.2246 38.7473 45.0571C38.3429 44.8895 37.9754 44.644 37.6659 44.3345C37.3563 44.0249 37.1108 43.6575 36.9433 43.2531C36.7758 42.8486 36.6896 42.4152 36.6896 41.9774V26.6663ZM40.0007 56.6663C39.2447 56.6663 38.5057 56.4422 37.8771 56.0222C37.2486 55.6022 36.7587 55.0052 36.4694 54.3068C36.1801 53.6084 36.1044 52.8399 36.2519 52.0984C36.3994 51.357 36.7634 50.6759 37.2979 50.1414C37.8325 49.6068 38.5135 49.2428 39.255 49.0953C39.9964 48.9479 40.7649 49.0235 41.4634 49.3128C42.1618 49.6021 42.7587 50.092 43.1787 50.7206C43.5987 51.3492 43.8229 52.0882 43.8229 52.8441C43.8229 53.8578 43.4202 54.83 42.7034 55.5468C41.9866 56.2636 41.0144 56.6663 40.0007 56.6663Z",
    fill: "#CD1919"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5082_8405",
    x: 9.33398,
    y: 13.333,
    width: 61.334,
    height: 61.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.852165 0 0 0 0 0.852165 0 0 0 0 0.852165 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5082_8405"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5082_8405",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5082_8405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayError);
export default __webpack_public_path__ + "static/media/payError.9cd579354559bb2f4c4ac274de384fe1.svg";
export { ForwardRef as ReactComponent };